import React, { useState, useEffect } from "react";
import FormikSelectTwo from "../../../../../Components/Utils/Select";
import EditIcon from "../../../../../Components/Icons/Edit";
import DeleteIcon from "../../../../../Components/Icons/Delete";
import Info from "../../../../../Components/Icons/Info";
import CloseIcon from "../../../../../Components/Icons/Close";
import useProductPriceListing from "../../../../../Components/Hooks/useProductPriceListing";
import { formatDisplaySno } from "../../../../../Components/Utils/formatDisplaySno";

function RFQHistoryRow({
  item,
  index,
  isEditQua,
  openPopupIndex,
  setOpenPopupIndex,
  onQuantityChange,
  onDeleteItem,
  selectedHist,
  handleSelectHistory,
  isSelectedRow,
  onToggleSelectRow,
}) {
  const productId = item?.productId || item?.product_id || item?.id;
  const { data: priceListingData, isLoading: isHistoryLoading } = useProductPriceListing(productId, {
    enabled: !!productId,
  });

  const rawQuotes = Array.isArray(priceListingData)
    ? priceListingData
    : priceListingData?.quotes || priceListingData?.price_history_list || item?.price_history_list || [];

  const historyList = rawQuotes.map((hist, histIdx) => {
    const rawPrice = hist?.price ?? hist?.unitPrice ?? hist?.unit_price;
    const priceVal = rawPrice !== null && rawPrice !== undefined ? rawPrice : "-";
    const supplierId = hist?.vendorId ?? hist?.supplierId ?? hist?.supplier_id ?? hist?.vendor_id ?? hist?.supplier;
    const quoteId = hist?.id ?? hist?._id ?? hist?.quotationId ?? hist?.quoteId ?? null;
    const poReceived = hist?.po_received === true || hist?.poReceived === true;
    const poRef = hist?.po_ref || hist?.poRef || hist?.po_number || hist?.poNumber || "";
    return {
      quoteId: quoteId,
      quoteIndex: histIdx,
      supplier: hist?.vendorName || hist?.supplier || hist?.supplier_name || hist?.vendor || "-",
      supplierId: supplierId,
      vendorId: hist?.vendorId,
      price: priceVal,
      currency: hist?.currency || "",
      date: hist?.date || hist?.created_at || "-",
      po_received: poReceived,
      po_ref: poRef,
      raw: hist,
    };
  });

  const isHistMatch = (h, target) =>
    target &&
    (target.quoteIndex !== undefined && h.quoteIndex !== undefined
      ? target.quoteIndex === h.quoteIndex
      : target.quoteId && h.quoteId
        ? target.quoteId === h.quoteId
        : target.supplier === h.supplier &&
        String(target.price) === String(h.price) &&
        target.currency === h.currency &&
        target.date === h.date);

  useEffect(() => {
    if (historyList.length > 0) {
      const existsInCurrentHistory =
        selectedHist && historyList.some((h) => isHistMatch(h, selectedHist));
      if (!existsInCurrentHistory) {
        // Auto select only if po_received is true
        const eligibleHist = historyList.find((h) => h.po_received === true) || null;
        handleSelectHistory(index, eligibleHist);
      }
    } else {
      if (selectedHist) {
        handleSelectHistory(index, null);
      }
    }
  }, [productId, priceListingData]);

  const activeHist =
    selectedHist && historyList.some((h) => isHistMatch(h, selectedHist))
      ? selectedHist
      : null;

  const displayUnitPrice = activeHist
    ? `${activeHist.currency ? activeHist.currency + " " : ""}${activeHist.price}`
    : item?.unitPrice ||
    item?.unit_price ||
    (item?.price_History?.price
      ? `${item?.price_History?.currency || ""} ${item?.price_History?.price}`
      : item?.price) ||
    "-";

  const displaySupplier = activeHist
    ? activeHist.supplier
    : item?.supplier ||
    item?.vendor ||
    item?.supplier_name ||
    item?.price_History?.supplier ||
    "-";

  const displayDate = activeHist
    ? activeHist.date
    : item?.date ||
    item?.price_History?.date ||
    item?.created_at ||
    "-";

  return (
    <div className="w-full min-w-[800px] py-2 flex items-center px-6 odd:bg-white even:bg-slate-100">
      <div className="w-[4%] shrink-0 text-center flex items-center justify-center">
        <input
          type="checkbox"
          checked={!!isSelectedRow}
          onChange={(e) => onToggleSelectRow && onToggleSelectRow(index, item, e.target.checked)}
          className="w-4 h-4 text-[#048178] border-gray-300 rounded focus:ring-[#048178] cursor-pointer accent-[#048178]"
        />
      </div>
      <p className="w-[5%] shrink-0 text-left text-xs font-medium text-[#111537] py-1 truncate">
        {item?.display_sno || item?.sno || index + 1}
      </p>
      <p className="w-[26%] shrink-0 min-w-0 text-left text-xs font-medium text-[#111537] truncate pr-2" title={item?.product_name}>
        {item?.product_name}
      </p>
      <p className="w-[10%] shrink-0 text-center text-xs font-medium text-[#111537] truncate px-1">
        {item?.product_unit}
      </p>
      <div className="w-[10%] shrink-0 text-center text-xs font-medium text-[#111537] flex items-center justify-center">
        <input
          type="number"
          className="w-full outline-none text-center bg-transparent"
          name="quantity"
          value={item?.quantity || ""}
          disabled={!isEditQua}
          onChange={(e) => onQuantityChange(e, index)}
        />
      </div>
      <p className="w-[15%] shrink-0 min-w-0 text-center text-xs font-medium text-[#111537] truncate px-1" title={displayUnitPrice}>
        {displayUnitPrice}
      </p>
      <p className="w-[15%] shrink-0 min-w-0 text-center text-xs font-medium text-[#111537] truncate px-1" title={displaySupplier}>
        {displaySupplier}
      </p>
      <p className="w-[10%] shrink-0 text-center text-xs font-medium text-[#111537] truncate px-1">
        {displayDate}
      </p>
      <div className="w-[5%] shrink-0 text-center flex items-center justify-center gap-2">
        <button
          type="button"
          className="p-1 focus:outline-none flex items-center justify-center hover:bg-teal-50 rounded cursor-pointer transition-colors"
          onClick={() =>
            setOpenPopupIndex(openPopupIndex === index ? null : index)
          }
          title="View Price History"
        >
          <Info color="#048178" width="16" height="16" />
        </button>

        {openPopupIndex === index && (
          <div
            className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4"
            onClick={() => setOpenPopupIndex(null)}
          >
            <div
              className="animate-scale-in w-[95vw] sm:w-[580px] md:w-[680px] max-w-full max-h-[85vh] bg-white rounded-xl shadow-2xl flex flex-col overflow-hidden border border-gray-100"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between px-5 py-3.5 bg-gradient-to-r from-teal-50/60 to-white border-b border-gray-200">
                <div className="flex items-center gap-2.5 overflow-hidden mr-3">
                  <div className="p-1.5 bg-[#048178]/10 rounded-lg text-[#048178] shrink-0">
                    <Info color="#048178" width="16" height="16" />
                  </div>
                  <div className="overflow-hidden text-left">
                    <h3 className="text-sm font-semibold text-[#111537]">
                      Price History
                    </h3>
                    <p
                      className="text-xs text-gray-500 truncate max-w-xs sm:max-w-md font-medium"
                      title={item?.product_name || "Product"}
                    >
                      {item?.product_name || "Product"}
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setOpenPopupIndex(null)}
                  className="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer shrink-0"
                  title="Close"
                >
                  <CloseIcon width="12" height="12" color="#64748b" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-4 overflow-y-auto max-h-[60vh]">
                {isHistoryLoading ? (
                  <div className="py-12 flex flex-col items-center justify-center text-gray-500 text-xs gap-2">
                    <div className="w-6 h-6 border-2 border-[#048178] border-t-transparent rounded-full animate-spin"></div>
                    <span>Loading price history...</span>
                  </div>
                ) : historyList.length > 0 ? (
                  <div className="border border-gray-200 rounded-lg overflow-hidden shadow-xs">
                    <table className="w-full text-left text-xs border-collapse">
                      <thead>
                        <tr className="border-b border-gray-200 text-[#111537] bg-teal-50/80 font-semibold">
                          <th className="py-2.5 px-3.5">Supplier</th>
                          <th className="py-2.5 px-3.5">PO No</th>
                          <th className="py-2.5 px-3.5 text-right">Price</th>
                          <th className="py-2.5 px-3.5 text-center">Date</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {historyList.map((hist, hIdx) => {
                          const isSelected = isHistMatch(hist, activeHist);

                          return (
                            <tr
                              key={hIdx}
                              onClick={() => handleSelectHistory(index, hist)}
                              className={`cursor-pointer transition-all duration-150 ${isSelected
                                ? "bg-[#048178] text-white font-medium"
                                : "odd:bg-white even:bg-slate-50/70 hover:bg-teal-50/60 text-gray-800"
                                }`}
                            >
                              <td
                                className={`py-2.5 px-3.5 truncate max-w-[180px] ${isSelected
                                  ? "text-white font-semibold"
                                  : "text-[#111537]"
                                  }`}
                                title={hist?.supplier || "-"}
                              >
                                <div className="flex items-center gap-2">
                                  <span
                                    className={`w-2 h-2 rounded-full shrink-0 ${isSelected ? "bg-white" : "bg-[#048178]"
                                      }`}
                                  />
                                  <span className="truncate">
                                    {hist?.supplier || "-"}
                                  </span>
                                </div>
                              </td>
                              <td
                                className={`py-2.5 px-3.5 whitespace-nowrap ${isSelected ? "text-teal-100" : "text-gray-600"
                                  }`}
                              >
                                {hist?.po_ref ? (
                                  <span
                                    className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium ${isSelected
                                      ? "bg-white/20 text-white"
                                      : "bg-slate-100 text-slate-700 border border-slate-200"
                                      }`}
                                  >
                                    {hist.po_ref}
                                  </span>
                                ) : (
                                  <span className="text-gray-400 text-[11px]">-</span>
                                )}
                              </td>
                              <td
                                className={`py-2.5 px-3.5 text-right font-semibold whitespace-nowrap ${isSelected ? "text-white" : "text-gray-900"
                                  }`}
                              >
                                {hist?.currency ? `${hist.currency} ` : ""}
                                {hist?.price !== undefined && hist?.price !== null
                                  ? hist.price
                                  : "-"}
                              </td>
                              <td
                                className={`py-2.5 px-3.5 text-center whitespace-nowrap ${isSelected ? "text-teal-100" : "text-gray-500"
                                  }`}
                              >
                                {hist?.date || "-"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="py-12 text-center text-gray-400 text-xs">
                    No price history available for this product
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="flex items-center justify-between px-5 py-3 bg-[#f8fafc] border-t border-gray-200">
                <span className="text-[11px] text-gray-500 font-medium">
                  {historyList.length > 0
                    ? "Click a row to select supplier & price"
                    : ""}
                </span>
                <button
                  type="button"
                  onClick={() => setOpenPopupIndex(null)}
                  className="px-4 py-1.5 bg-[#048178] hover:bg-[#036962] text-white text-xs font-medium rounded-lg transition-colors cursor-pointer shadow-xs"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={() => onDeleteItem(index)}
          type="button"
          className="text-red-500 cursor-pointer border-none p-1 hover:bg-red-50 rounded"
          title="Delete item"
        >
          <DeleteIcon color="red" height={4} />
        </button>
      </div>
    </div>
  );
}

export default function RFQHistoryTable({
  prlist,
  error,
  formik,
  deletedItemDropDown,
  onAddProduct,
  onQuantityChange,
  onDeleteItem,
  selectedHistoryMap: parentSelectedHistoryMap,
  setSelectedHistoryMap: parentSetSelectedHistoryMap,
  selectedRows: parentSelectedRows,
  setSelectedRows: parentSetSelectedRows,
  onSelectRow: parentOnSelectRow,
  onSelectAllRows: parentOnSelectAllRows,
}) {
  const [isEditQua, setIsEditQua] = useState(false);
  const [openPopupIndex, setOpenPopupIndex] = useState(null);
  const [localSelectedHistoryMap, setLocalSelectedHistoryMap] = useState({});
  const [localSelectedRows, setLocalSelectedRows] = useState([]);

  const selectedHistoryMap = parentSelectedHistoryMap || localSelectedHistoryMap;
  const setSelectedHistoryMap = parentSetSelectedHistoryMap || setLocalSelectedHistoryMap;

  const selectedRows = parentSelectedRows !== undefined ? parentSelectedRows : localSelectedRows;

  const handleSelectHistory = (index, hist) => {
    setSelectedHistoryMap((prev) => ({
      ...prev,
      [index]: hist,
    }));
  };

  const isRowSelected = (index) => {
    if (Array.isArray(selectedRows)) {
      return selectedRows.includes(index);
    }
    if (selectedRows && typeof selectedRows === "object") {
      return !!selectedRows[index];
    }
    return false;
  };

  const handleToggleSelectRow = (index, item, isChecked) => {
    if (parentOnSelectRow) {
      parentOnSelectRow(index, item, isChecked);
      return;
    }
    if (parentSetSelectedRows) {
      if (Array.isArray(selectedRows)) {
        parentSetSelectedRows(
          isChecked
            ? [...selectedRows, index]
            : selectedRows.filter((i) => i !== index)
        );
      } else if (typeof selectedRows === "object") {
        parentSetSelectedRows({
          ...selectedRows,
          [index]: isChecked,
        });
      }
      return;
    }
    setLocalSelectedRows((prev) =>
      isChecked ? [...prev, index] : prev.filter((i) => i !== index)
    );
  };

  const isAllSelected =
    prlist?.length > 0 && prlist.every((_, idx) => isRowSelected(idx));

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    if (parentOnSelectAllRows) {
      parentOnSelectAllRows(checked, prlist);
      return;
    }
    const allIndexes = checked ? prlist.map((_, idx) => idx) : [];
    if (parentSetSelectedRows) {
      parentSetSelectedRows(allIndexes);
      return;
    }
    setLocalSelectedRows(allIndexes);
  };

  return (
    <div className="w-full">
      {deletedItemDropDown && deletedItemDropDown.length > 0 ? (
        <div className="w-full flex justify-start gap-2">
          <FormikSelectTwo
            type="text"
            label="Product"
            placeholder="Product"
            Options={deletedItemDropDown}
            formik={formik}
            name="productId"
            width="w-full md:w-1/2 lg:w-[67%]"
          />
          <button
            onClick={onAddProduct}
            type="button"
            className="p-1 mt-[44px] m-1 text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white text-xs font-medium text-white rounded-lg"
          >
            Add
          </button>
        </div>
      ) : null}

      <div className="w-full bg-white overflow-auto">
        {error && (
          <p className="text-xs font-semibold text-red-500 mb-2">{error}</p>
        )}
        <div className="w-full min-w-[800px] py-2 bg-[#048178] flex items-center rounded-lg px-6">
          <div className="w-[4%] shrink-0 text-center flex items-center justify-center">
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={handleSelectAll}
              className="w-4 h-4 text-[#048178] border-gray-300 rounded focus:ring-[#048178] cursor-pointer accent-[#048178]"
              title="Select All"
            />
          </div>
          <p className="w-[5%] shrink-0 text-left text-white text-xs font-medium">S.No</p>
          <p className="w-[26%] shrink-0 min-w-0 text-left text-white text-xs font-medium pr-2">Product</p>
          <p className="w-[10%] shrink-0 text-center text-white text-xs font-medium">Unit</p>
          <p className="w-[10%] shrink-0 text-center text-white text-xs font-medium flex justify-center items-center">
            Quantity
            <span
              className="pl-1 cursor-pointer"
              onClick={() => setIsEditQua((prv) => !prv)}
            >
              <EditIcon width={"14"} height={"14"} color={isEditQua ? "yellow" : undefined} />
            </span>
          </p>
          <p className="w-[15%] shrink-0 min-w-0 text-center text-white text-xs font-medium">Unit Price</p>
          <p className="w-[15%] shrink-0 min-w-0 text-center text-white text-xs font-medium">Supplier</p>
          <p className="w-[10%] shrink-0 text-center text-white text-xs font-medium">Date</p>
          <p className="w-[5%] shrink-0 text-center text-white text-xs font-medium">Action</p>
        </div>

        {prlist?.length > 0 ? (
          <div className="h-[calc(100vh-300px)] min-w-[800px] overflow-auto">
            {formatDisplaySno(prlist || []).map((item, index) => (
              <RFQHistoryRow
                key={index}
                item={item}
                index={index}
                isEditQua={isEditQua}
                openPopupIndex={openPopupIndex}
                setOpenPopupIndex={setOpenPopupIndex}
                onQuantityChange={onQuantityChange}
                onDeleteItem={onDeleteItem}
                selectedHist={selectedHistoryMap[index]}
                handleSelectHistory={handleSelectHistory}
                isSelectedRow={isRowSelected(index)}
                onToggleSelectRow={handleToggleSelectRow}
              />
            ))}
          </div>
        ) : (
          <div className="w-full text-[#93949f] text-center py-4">No Items here</div>
        )}
      </div>
    </div>
  );
}


